import { Model, Attr, HasOne, HasMany } from 'spraypaint';
import ApplicationRecord from 'spa-ionata-admin/lib/models/ApplicationRecord';
import User from './User';
import Media from './Media';

@Model()
export default class BusinessLead extends ApplicationRecord {
  static jsonapiType = 'business-leads';

  // --- Attributes
  // --------------

  // required
  @Attr() firstName!: string;

  // required
  @Attr() lastName!: string;

  // required
  // maxLength: 254
  @Attr() email!: string;

  // required
  @Attr() phone!: string;

  // required
  @Attr() businessName!: string;

  @Attr() content!: HashAny | null;

  // readOnly
  @Attr() createdAt!: string | null;

  // readOnly
  @Attr() modifiedAt!: string | null;

  // --- Relationships
  // -----------------

  // nullable
  @HasOne() logo!: Media | null;

  @HasMany() images!: Media[];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @HasMany() supportingDocuments!: any[];

  // nullable
  @HasOne() createdBy!: User | null;

  // nullable
  @HasOne() modifiedBy!: User | null;

  // --- Paths
  // ---------

  /**
   * /backend/api/v1/business-leads/
   *
   * Method: post
   * Body:
   *   - first_name: string (required)
   *   - last_name: string (required)
   *   - email: string (format: email) (maxLength: 254) (required)
   *   - phone: string (required)
   *   - business_name: string (required)
   *   - content: object
   *
   */

  /**
   * /backend/api/v1/business-leads/{id}/images/
   *
   * Method: post
   * Params:
   *   - id: string (required)
   * Body:
   *
   */

  /**
   * /backend/api/v1/business-leads/{id}/logo/
   *
   * Method: post
   * Params:
   *   - id: string (required)
   * Body:
   *   - image: file (required)
   *
   */

  /**
   * /backend/api/v1/business-leads/{id}/supporting-documents/
   *
   * Method: post
   * Params:
   *   - id: string (required)
   * Body:
   *
   */
}
